#import "../../../../graphql-wrappers/broadcast/graphql/fragments/broadcast-fragment.graphql"

mutation RegenerateAiEmailTemplate($input: AiEmailTemplateRegenerateInput!) {
    aiEmailTemplateRegenerate(input: $input) {
        campaign {
            ...BroadcastFragment
        }
    }
}
